import { replace } from 'lodash';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const CurrencyInputDivBlock = styled.div`
    height: ${props => props.height || '40px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
    width: ${props => props.width || '100%'};
    float: ${props => props.float || 'left'};
`;

const CurrencyInputBlock = styled.input`
    height: 40px;
    width: ${props => props.width || '179px'};
    padding: 0 32px 0 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: ${props => props.textAlign || 'right'};
    font-size: ${props => props.fontSize || '14px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
    font-weight: ${props => props.fontWeight || '700'};

    &:focus {
        border: ${props => props.focusBorder};
        outline: 0
    }

    ::-webkit-input-placeholder {
        color: #ccc
    }

    ::-moz-placeholder {
        color: #ccc
    }

    ::-ms-input-placeholder {
        color: #ccc
    }

    ::placeholder {
        color: #ccc
    }
    :focus {
        outline: 0
    }
`;

const CurrencyInputComp = ({ float, height, maxLength, placeholder,
    marginBottom, marginTop, marginLeft, marginRight,
    marginInnerTop, onBlur, onFocus,
    onChange, disabled, fontSize,
    width,
    inputRef, textAlign, fontWeight, firstValue = 0 }) => {

    const [strPrice, setStrPrice] = useState('');
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(0);

    var setting = {
        maxLength: maxLength,
        placeholder: placeholder,
        marginTop: marginInnerTop,
        focusBorder: '1px solid #ffc742',
        disabled: disabled,
        fontSize: fontSize,
        textAlign: textAlign,
        fontWeight: fontWeight,
        width: width
    }

    useEffect(() => {

        if(strPrice.length > 0) {
            inputRef.current.selectionStart = start;
            inputRef.current.selectionEnd = end;
        }

        /* inputRef.current.selectionStart = start;
        inputRef.current.selectionEnd = end; */

    }, [start, strPrice])

    useEffect(() => {
        if(firstValue*1 > 0) {
            setStrPrice(Number(firstValue.toFixed(1)).toLocaleString());
        }
    }, [])

    const handleInputChange = (e) => {

        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        const beforeLength = e.target.value.length;
        let afterLength = 0;
        let margin = 0;



        //console.log("1------->" + e.target.value);
        // console.log("start : " + e.target.selectionStart)
        // console.log("end : " + e.target.selectionEnd)

        // remove comma
        let numPrice = replace(e.target.value, /,/g, "");
        numPrice = numPrice * 1;

        // console.log("2-------------------->" + numPrice);

        // 문자 입력 방지 , 음수 방지
        if (isNaN(numPrice) || numPrice < 0) {
            return;
        }

        // Display Comma 
        setStrPrice(Number(numPrice.toFixed(1)).toLocaleString());

        afterLength = Number(numPrice.toFixed(1)).toLocaleString().length;

        // Start 위치가 Before Length 와 같으면 +1
        if (start === beforeLength || afterLength > beforeLength) {
            ++margin;
        } else if (beforeLength > afterLength) {
            --margin;
        }

        setStart(start + margin);
        setEnd(end + margin);

        if (onChange != null && onChange !== undefined) {
            onChange(numPrice);
        }
    }

    const handeBlur = () => {
        // console.log("handeBlur ++++++++");
        if (onBlur !== null && onBlur !== undefined) {
            onBlur();
        }
    }

    const handleFocus = () => {
        // console.log("handleFocus ------>")
        if (onFocus !== null && onFocus !== undefined) {
            onFocus();
        }
    }

    return (
        <CurrencyInputDivBlock
            float={float}
            height={height}
            width={width}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}>
            <CurrencyInputBlock
                {...setting}
                ref={inputRef}
                value={strPrice}
                onChange={handleInputChange}
                onBlur={() => { handeBlur() }}
                onFocus={() => { handleFocus() }}
                inputMode='decimal' 
            />
        </CurrencyInputDivBlock>

    );
};

export default CurrencyInputComp;